/**
 * Word count for an entry.
 *
 * It is materialized in `journal_entry.word_count` when saving so statistics
 * are O(1) (without scanning bodies). Unicode-aware: it counts sequences with
 * at least one letter or number (it works for es/en, and CJK falls back to a
 * reasonable block-based approximation).
 */
const WORD_RE = /[\p{L}\p{N}]+(?:['’-][\p{L}\p{N}]+)*/gu;

export function countWords(text: string | null | undefined): number {
  if (!text) return 0;
  return text.match(WORD_RE)?.length ?? 0;
}
